import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Banniere, BanniereService } from '@helvetia/components';
import { MarketService } from 'src/app/services/market.service';
import { ModalInfoComponent } from '../modal-info/modal-info.component';

@Component({
  selector: 'app-markets',
  templateUrl: './markets.component.html',
  styleUrls: ['./markets.component.scss']
})
export class MarketsComponent {

  @Input() market: any;
  @Input() markets: any;
  @Output() triggerRefresh = new EventEmitter<any>();

  constructor(public router: Router,
    public marketService: MarketService,
    public dialog: MatDialog,
    private banniereService: BanniereService
  ) {

  }

  viewMarket() {
    this.router.navigate(['documents/' + this.market.id])
  }

  editMarket() {
    this.router.navigate(['marche/' + this.market.id])
  }

  changeOrderUp() {
    this.marketService.changeOrderUp(this.market.id).subscribe(
      (data) => {
        this.markets = data
        this.triggerRefresh.emit(this.markets);
      }
    )
  }

  changeOrderDown() {
    this.marketService.changeOrderDown(this.market.id).subscribe(
      (data) => {
        this.markets = data
        this.triggerRefresh.emit(this.markets);
      }
    )
  }

}
